import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "head" }
const _hoisted_2 = {
  id: "sticky_sidebar",
  class: "tf__cart_list_footer_button top-20 ssticky-top cart"
}
const _hoisted_3 = {
  key: 0,
  class: "tf__cart_list_footer_button_text"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h6", { class: "mb_20" }, " Votre panier ", -1)
const _hoisted_5 = { class: "productsOnCart" }
const _hoisted_6 = { class: "d-flex" }
const _hoisted_7 = { class: "productName d-flex justify-content-start" }
const _hoisted_8 = { class: "quantity d-flex justify-content-start" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "m_0 p_0" }
const _hoisted_12 = { class: "m_0 p_0" }
const _hoisted_13 = { class: "productPrice text-end" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "groupName d-flex justify-content-start" }
const _hoisted_16 = { class: "m_0 p_0" }
const _hoisted_17 = {
  key: 0,
  class: "text-decoration-line-throughss"
}
const _hoisted_18 = {
  key: 1,
  class: "text-decoration-line-throughss"
}
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "groupName d-flex justify-content-start" }
const _hoisted_21 = { class: "m_0 p_0" }
const _hoisted_22 = { style: {"width":"100%"} }
const _hoisted_23 = { class: "float-end" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_25 = { class: "text-end" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { class: "text-end" }
const _hoisted_28 = { key: 1 }
const _hoisted_29 = { class: "text-end" }
const _hoisted_30 = { key: 2 }
const _hoisted_31 = { class: "text-end" }
const _hoisted_32 = { key: 3 }
const _hoisted_33 = { class: "text-end" }
const _hoisted_34 = { class: "total" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", null, " Total:", -1)
const _hoisted_36 = { class: "text-end" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_38 = {
  key: 1,
  class: "tf__cart_list_footer_button_text"
}
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "tf__notfound_text wow fadeInUp text-center mt_30 mb_30" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Panier vide. Vous pouvez commencer à ajouter des produits.")
], -1)
const _hoisted_40 = [
  _hoisted_39
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_custom_modal_add_to_cart = _resolveComponent("custom-modal-add-to-cart")!
  const _component_modal_tables_component = _resolveComponent("modal-tables-component")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["col-xl-4 col-lg-4 col-md-5 col-sm-12 col-12 wow fadeInUp section-cart", { displayCartMobile: $data.openCartMobile }])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createTextVNode(" Votre panier "),
        _createElementVNode("div", {
          class: "closeModal close_icon",
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($data.openCartMobile = false))
        })
      ]),
      _createElementVNode("div", _hoisted_2, [
        (_ctx.cartStore?.products?.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cartStore?.products, (product, productIndex) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "item mb_20",
                    key: productIndex
                  }, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("div", {
                            onClick: ($event: any) => ($options.PlusMinusQteProduct('minus', product, productIndex)),
                            class: "decrease cursor-pointer"
                          }, " - ", 8, _hoisted_9),
                          _createElementVNode("span", null, _toDisplayString(product.quantity), 1),
                          _createElementVNode("div", {
                            onClick: ($event: any) => ($options.PlusMinusQteProduct('plus', product, productIndex)),
                            class: "increase cursor-pointer"
                          }, " + ", 8, _hoisted_10)
                        ]),
                        _createElementVNode("div", null, [
                          _createElementVNode("p", _hoisted_11, _toDisplayString(product?.category_name) + " - " + _toDisplayString($data.ProductUtils.productName(product)), 1),
                          _createElementVNode("p", _hoisted_12, _toDisplayString(product?.promotion?.text), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", null, [
                          _createElementVNode("span", null, " € " + _toDisplayString((
                                                $data.ProductUtils.productPrice(product) * product.quantity
                                            ).toFixed(2)), 1),
                          _createElementVNode("div", null, [
                            _createElementVNode("span", {
                              class: "cursor-pointer",
                              onClick: ($event: any) => ($options.PreparerYourProduct(product, productIndex))
                            }, "Modifier ", 8, _hoisted_14)
                          ])
                        ])
                      ])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(product.groups.filter(
                            (group) =>
                                group.button_type == 'CheckboxButton' &&
                                group.sub_products.find((subProduct) => subProduct.checked)
                        ), (group) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "group mb_10 pl_20 pr_20",
                        key: _ctx.groupIndex
                      }, [
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("div", null, [
                            _createElementVNode("p", _hoisted_16, _toDisplayString(group.title), 1)
                          ])
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.sub_products.filter(
                                (subProduct) => subProduct.checked
                            ), (subProduct) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "subProductName d-flex justify-content-between",
                            key: _ctx.subProductIndex
                          }, [
                            (subProduct?.ingredient)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                  _createElementVNode("span", null, _toDisplayString(subProduct?.ingredient?.name), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (subProduct?.supplement)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                  _createElementVNode("span", null, _toDisplayString(subProduct?.supplement?.name), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ]))
                    }), 128)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(product.groups.filter(
                            (group) =>
                                (group.button_type == 'RadioButton' &&
                                    group.type != 'size') ||
                                group.button_type == 'PlusMinusButton'
                        ), (group) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "group mb_10 pl_20 pr_20",
                        key: _ctx.groupIndex
                      }, [
                        (group.used)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                              _createElementVNode("div", _hoisted_20, [
                                _createElementVNode("div", null, [
                                  _createElementVNode("p", _hoisted_21, _toDisplayString(group.title), 1)
                                ])
                              ]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group?.sub_products.filter(
                                    (subProduct) => subProduct.quantity || subProduct.checked
                                ), (subProduct) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "subProductName d-flex justify-content-between",
                                  key: _ctx.groupIndex
                                }, [
                                  _createElementVNode("div", _hoisted_22, [
                                    _createElementVNode("span", null, _toDisplayString(subProduct.quantity || 1) + " x " + _toDisplayString(subProduct?.supplement ? subProduct?.supplement?.name :
                                                subProduct?.ingredient?.name), 1),
                                    _createElementVNode("span", _hoisted_23, "€ " + _toDisplayString((product.quantity * subProduct.price).toFixed(2)), 1)
                                  ])
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]))
                }), 128))
              ]),
              _hoisted_24,
              _createElementVNode("p", null, [
                _createTextVNode(" Sous total: "),
                _createElementVNode("span", _hoisted_25, "€ " + _toDisplayString(_ctx.cartStore?.subTotal.toFixed(2)), 1)
              ]),
              (_ctx.cartStore?.deliveryMode == 'liv')
                ? (_openBlock(), _createElementBlock("p", _hoisted_26, [
                    _createTextVNode(_toDisplayString(_ctx.$t("store.priseCommande.cart.fees")) + ": ", 1),
                    _createElementVNode("span", _hoisted_27, "€ " + _toDisplayString(_ctx.cartStore?.deliveryTotal.toFixed(2)), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.cartStore?.discountCouponcode > 0)
                ? (_openBlock(), _createElementBlock("p", _hoisted_28, [
                    _createTextVNode(" Promo code : " + _toDisplayString(_ctx.storeData?.couponCode?.data?.code_number) + ", " + _toDisplayString(_ctx.storeData?.couponCode?.data?.percentage) + " % ", 1),
                    _createElementVNode("span", _hoisted_29, " € -" + _toDisplayString((_ctx.cartStore?.discountCouponcode).toFixed(2)), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.cartStore.discountFidelite > 0)
                ? (_openBlock(), _createElementBlock("p", _hoisted_30, [
                    _createTextVNode(" Loyalty " + _toDisplayString(_ctx.storeData?.data?.config_loyalty[0]?.percentage) + " % : ", 1),
                    _createElementVNode("span", _hoisted_31, "€ -" + _toDisplayString(_ctx.cartStore.discountFidelite.toFixed(2)), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.cartStore.discountPromotions > 0)
                ? (_openBlock(), _createElementBlock("p", _hoisted_32, [
                    _createTextVNode(" Promotions : "),
                    _createElementVNode("span", _hoisted_33, "€ -" + _toDisplayString(_ctx.cartStore.discountPromotions.toFixed(2)), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("p", _hoisted_34, [
                _hoisted_35,
                _createElementVNode("span", _hoisted_36, "€ " + _toDisplayString((_ctx.cartStore?.totalFinal).toFixed(2)), 1)
              ]),
              _hoisted_37,
              _createElementVNode("a", {
                href: "javascript:void(0)",
                class: "common_btn w-100 d-block",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($options.checkout && $options.checkout(...args)))
              }, " Commander maintenant ")
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_38, _hoisted_40))
      ])
    ], 2),
    _createElementVNode("div", {
      class: "showCartMobile",
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($options.showCartMobile && $options.showCartMobile(...args)))
    }, "Votre panier"),
    ($data.isModalAddToCartOpen)
      ? (_openBlock(), _createBlock(_component_custom_modal_add_to_cart, {
          key: 0,
          modelValue: $data.isModalAddToCartOpen,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($data.isModalAddToCartOpen) = $event)),
          product: _ctx.productsStore?.currentProduct,
          action: 'edit',
          indexProduct: $data.indexProduct,
          onToggleAddToCart: $options.handleToggleAddToCart,
          isModalAddToCartOpen: $data.isModalAddToCartOpen
        }, null, 8, ["modelValue", "product", "indexProduct", "onToggleAddToCart", "isModalAddToCartOpen"]))
      : _createCommentVNode("", true),
    ($data.isModalTableOpen)
      ? (_openBlock(), _createBlock(_component_modal_tables_component, {
          key: 1,
          onToggleSelectTable: $options.handleToggleSelectTable
        }, null, 8, ["onToggleSelectTable"]))
      : _createCommentVNode("", true)
  ], 64))
}